import App from './indexC'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { onAuthStateChanged } from '../../reducers/authState'

const mapStateToProps = (state) => {
  const { login, emailVerified } = state.authState
  return {
    login: login,
    emailVerified: emailVerified
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAuthStateChanged: (authState) => {
      dispatch(onAuthStateChanged(authState))
    }
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(App))



// WEBPACK FOOTER //
// ./src/components/App/index.js